/**
 * Scroll doux vers les ancres de la page.
 *
 * Conteneurs [data-anchor-scroll] : un clic sur un lien interne (même page, avec #)
 * déclenche un scroll doux avec le décalage du header au lieu du saut natif.
 * Remplace le composant Vue Hero (boutons CTA du bloc hero).
 */
UNYC.register('anchor-scroll', () => {
    UNYC.init('[data-anchor-scroll]', 'anchor-scroll', (container) => {
        container.addEventListener('click', (event) => {
            const link = event.target instanceof Element ? event.target.closest('a[href*="#"]') : null;

            if (!link || !container.contains(link) || !UNYC.isSamePageAnchor(link)) return;

            if (UNYC.scrollTo(link.hash)) {
                event.preventDefault();
            }
        });
    });
});
